import {useEffect, useState} from "react";
import {create} from "custom/demo/requests/admin/validation-reports";
import {list as listStudies} from "custom/demo/requests/admin/validation-studies";
import Field from "components/helpers/form/field";
import useForm from "custom/demo/helpers/admin/use-form";
import useAppContext from "lib/hooks/use-app-context";

const defaults = {
  email: "",
  name: "",
  retest: false,
  validation_study_id: ""
};

export default function Form() {
  const {user} = useAppContext();
  const {onChange, onSubmit, record} = useForm({
    actions: {create},
    defaults: {...defaults, email: user?.profile?.email || ""},
    path: "/admin/validation/reports"
  });
  const [studyOptions, setStudyOptions] = useState([]);

  useEffect(() => {
    listStudies().then((data) => {
      setStudyOptions(data.records.map((s) => ({name: s.name, value: String(s.id)})));
    });
  }, []);

  return (
    <div className="container">
      <h1>Validation Report</h1>
      <form onSubmit={onSubmit}>
        <Field
          label="Email"
          name="email"
          onChange={onChange}
          placeholder="Email"
          required={true}
          type="email"
          value={record.email}
        />
        <Field
          label="Name"
          name="name"
          onChange={onChange}
          placeholder="Name"
          required={true}
          value={record.name}
        />
        <Field
          checked={record.retest}
          label="Retest"
          name="retest"
          onChange={onChange}
          type="checkbox"
        />
        <Field
          label="Study"
          name="validation_study_id"
          onChange={onChange}
          options={studyOptions}
          placeholder="Select Study"
          type="select"
          value={record.validation_study_id}
        />
        <div className="flex gap-2 mt-4">
          <button className="btn btn-blue" type="submit">Save</button>
        </div>
      </form>
    </div>
  );
}
